import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
// tslint:disable-next-line:max-line-length
import { HasMaintenanceTaskUserNotificationNotReadBuilder } from '../../models/builders/has-maintenance-task-user-notification-not-read.builder';
import { UserNotificationCounterBuilder } from '../../models/builders/user-notification-counter.builder';
import { UserNotificationBuilder } from '../../models/builders/user-notification.builder';
import { UserNotificationsBuilder } from '../../models/builders/user-notifications.builder';

@Injectable()
export class UserNotificationApiService {

  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${environment.apiUrl}user-notifications`;
  }

  getUserNotifications(sort: string, isReversed: boolean, page: number, size: number,
    filter: string = '', userFilter: string = '', startDate?: number,
    endDate?: number, isRead?: boolean) {
    let params = new HttpParams()
      .set('sort', sort)
      .set('isReversed', (!isReversed).toString())
      .set('page', page.toString())
      .set('size', size.toString())
      .set('filter', filter)
      .set('userFilter', userFilter);

    if (startDate !== undefined && startDate !== null && !isNaN(startDate)) {
      params = params.set('dateFrom', startDate.toString());
    }
    if (endDate !== undefined && endDate !== null && !isNaN(endDate)) {
      params = params.set('dateTo', endDate.toString());
    }
    if (isRead !== undefined && isRead !== null && 'undefined' !== (isRead.toString())) {
      params = params.set('isRead', isRead.toString());
    }
    return this.httpClient.get(`${this.apiUrl}`, { params })
      .pipe(
        map(UserNotificationsBuilder.fromJson)
      );
  }

  getUserNotificationsIsNotRead() {
    return this.httpClient.get(`${this.apiUrl}/is-not-read`)
      .pipe(
        map(UserNotificationBuilder.fromList)
      );
  }


  getUserNotificationIsNotReadCounter() {
    return this.httpClient.get(`${this.apiUrl}/is-not-read-counter`)
      .pipe(
        map(UserNotificationCounterBuilder.fromJson)
      );
  }

  markUserNotificationAsRead(hash: string) {
    return this.httpClient.put(`${this.apiUrl}/${hash}/mark-as-read`, null)
      .pipe(
        map(UserNotificationCounterBuilder.fromJson)
      );
  }

  markUserNotificationAsNotRead(hash: string) {
    return this.httpClient.put(`${this.apiUrl}/${hash}/mark-as-not-read`, null)
      .pipe(
        map(UserNotificationCounterBuilder.fromJson)
      );
  }

  hasMaintenanceTaskUserNotificationNotRead() {
    return this.httpClient.get(`${this.apiUrl}/maintenance-task-today`)
      .pipe(
        map(HasMaintenanceTaskUserNotificationNotReadBuilder.fromJson)
      );
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/user-notification-api.service.ts